import { StyleSheet } from "@react-pdf/renderer";

export const styles = StyleSheet.create({
    root: {
        flexDirection: "row",
        fontWeight: 400,
        fontSize: 9,
        minHeight: 36,
        marginTop: 24,
        borderBottom: "1px solid #D0D0D0",
    },
    articleColumnContainer: {
        paddingLeft: 5,
        flex: 5,
        justifyContent: "center",
    },
    articleNrColumnContainer: {
        flex: 3,
        justifyContent: "center",
    },
    modelColumnContainer: {
        flex: 6,
        justifyContent: "center",
    },
    availabilityColumnContainer: {
        flex: 4,
        justifyContent: "center",
    },
    priceColumnContainer: {
        flex: 2,
        justifyContent: "center",
    },
    quantityColumnContainer: {
        flex: 1,
        justifyContent: "center",
    },
});
